import "vant/es/toast/style";
import _Toast from "vant/es/toast";
export default {
  name: "integral-sign-in",
  components: {
    Toast: _Toast
  },
  data: function data() {
    return {};
  },
  methods: {
    onClickRight: function onClickRight() {
      _Toast("签到");
    }
  }
};